module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.session) ? _c('simulator', {
    attrs: {
      "session": _vm.session
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.session) ? _c('welcome') : _vm._e()], 1), _vm._v(" "), _c('editorTabs', {
    ref: "tabs"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-187a4d39!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/Workbench.vue
// module id = 1531
// module chunks = 2